// src/components/utils/achievements.js
const STORAGE_KEY = "achievements_unlocked";
const EVENT_NAME = "achievement:unlocked";

export const ACHIEVEMENTS = {
  "nick-song": {
    code: "nick-song",
    title: "DJ Ник",
    description: "Нажал на ник — заиграла песня.",
    icon: "🎵",
  },
  "win-404": {
    code: "win-404",
    title: "Победитель 404",
    description: "Выиграл игру на странице 404.",
    icon: "🏆",
  },
};

function read() {
  try {
    const arr = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}
function write(list) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
}

export const getUnlockedCodes = () => read();
export const getUnlockedDetails = () =>
  getUnlockedCodes().map((c) => ACHIEVEMENTS[c]).filter(Boolean);
export const hasAchievement = (code) => read().includes(code);

export function awardAchievement(code, overrides = {}) {
  if (!ACHIEVEMENTS[code])
    ACHIEVEMENTS[code] = { code, title: code, description: "", icon: "✨" };

  const curr = read();
  if (curr.includes(code)) return { unlocked: false, detail: ACHIEVEMENTS[code] };

  const detail = { ...ACHIEVEMENTS[code], ...overrides };
  write([...curr, code]);

  try {
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail }));
  } catch {}

  return { unlocked: true, detail };
}

export function onAchievementUnlocked(handler) {
  const fn = (e) => handler(e.detail);
  window.addEventListener(EVENT_NAME, fn);
  return () => window.removeEventListener(EVENT_NAME, fn);
}
